import CreatePeer from '../createPeer';
import Player from './Player';
import PlayerCollection from './PlayerCollection';
import Game from './GameController';

const server = (logger = console) => {
  const _game = new Game(gameOver);
  let _peer = null;
  let _playerCollection = new PlayerCollection();
  let _isStarted = false;
  let _wordList = [];

  function gameOver(winnerTeam) {
    _isStarted = false;
    _playerCollection.send('gameOver', { winner: winnerTeam });
    _game.resetCodeMaster();
    sendGameInfo();
  }

  function sendGameInfo() {
    const gameStateRevealed = _game.toJson();
    const gameState = {
      ...gameStateRevealed,
      board: gameStateRevealed.board.map((cell) => {
        if (!cell.revealed) {
          return { ...cell, type: null };
        }

        return cell;
      }),
    };
    _playerCollection.iterate((player) => {
      const isCodeMaster = _game.isCodeMaster(player);
      const state = isCodeMaster ? gameStateRevealed : gameState;
      state.player = player.toJson();
      state.player.isCodeMaster = isCodeMaster;
      player.send('state', state);
    });
  }

  function handleData(player, data) {
    if (!('action' in data)) {
      return;
    }

    switch (data.action) {
      case 'choseTeam':
        _game.addPlayer(data.team, player);
        break;

      case 'beCodemaster':
        _game.defineCodeMaster(player);
        break;

      case 'reveal':
        _game.reveal(player, data.cell);
        break;

      case 'changeTurn':
        _game.endTurn();
        break;
    }

    sendGameInfo();
  }

  return {
    setColorTeamA(color) {
      _game.colorTeamA = color;
    },
    setColorTeamB(color) {
      _game.colorTeamB = color;
    },
    setWordList: (wordList) => {
      _wordList = wordList;
    },
    isServerOpen() {
      return _peer !== null && !_peer.disconnected && !_peer.destroyed;
    },
    create(peerReadyCallback) {
      if (this.isServerOpen()) {
        return;
      }

      _peer = CreatePeer(console, peerReadyCallback);
      _peer.on('connection', (connection) => {
        logger.info('New connection from ' + connection.peer);
        connection.on('open', () => {
          const player = new Player(connection);
          _playerCollection.add(player);

          logger.info(`New player ${player.name} (ID: ${player.id}) joined`);

          connection.on('data', (data) => {
            handleData(player, data);
          });

          connection.on('close', () => {
            _playerCollection.remove(connection.peer);
            logger.info('User ' + connection.peer + ' left');

            if (
              _isStarted &&
              _game.checkGameRequirements(_wordList).length > 0
            ) {
              gameOver('');
            }
          });

          sendGameInfo();
        });
      });
    },
    start: () => {
      const errors = _game.start(_wordList);

      if (errors.length > 0) {
        alert('Can not start game!\n\n' + errors.join('\n'));
        return false;
      }

      _isStarted = true;
      sendGameInfo();

      return true;
    },
  };
};

export default server;
